import { render, staticRenderFns } from "./RecordBuy.vue?vue&type=template&id=1328c788&scoped=true&"
import script from "./RecordBuy.vue?vue&type=script&lang=js&"
export * from "./RecordBuy.vue?vue&type=script&lang=js&"
import style0 from "./RecordBuy.vue?vue&type=style&index=0&id=1328c788&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328c788",
  null
  
)

export default component.exports